var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../I18N";





export const ErrorFallback = ({ error }) => {
  const currentError = error;
  const showRequestId = currentError.status === 500 && currentError.requestId;
  return (/*#__PURE__*/
    _jsx("div", { className: "tw-content" }, void 0, /*#__PURE__*/
    _jsx("section", { className: "h-full bg-white" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "max-w-screen-xl px-4 py-8 mx-auto lg:py-16 lg:px-6" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "max-w-screen-sm mx-auto text-center" }, void 0,
    currentError.status && /*#__PURE__*/
    _jsx("h1", { className: "mb-4 font-extrabold tracking-tight text-gray-500 text-7xl lg:text-9xl " }, void 0,
    currentError.status
    ), /*#__PURE__*/

    _jsx("p", { className: "mb-4 text-3xl font-bold tracking-tight text-gray-900 md:text-4xl " }, void 0,
    error.name && /*#__PURE__*/_jsx(Translate, {}, void 0, currentError.name),
    !error.name && /*#__PURE__*/_jsx(Translate, {}, void 0, "Well, this is awkward...")
    ),
    error.message && /*#__PURE__*/
    _jsx("p", {
      "data-testid": "errorInfo",
      className: "mb-4 text-lg font-light text-gray-500 dark:text-gray-400" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, currentError.message),
    showRequestId && /*#__PURE__*/
    _jsx("span", { "data-testid": "requestId" }, void 0, ".\xA0", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Request id #"),
    currentError.requestId
    )

    ),

    currentError.stack && /*#__PURE__*/
    _jsx("pre", { className: "mb-4 font-mono text-sm text-left text-gray-500 dark:text-gray-400" }, void 0,
    currentError.stack
    )

    )
    )
    )
    ));

};